import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./poi.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./poi.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { TableSearchComponent } from "../../shared/components/table-search/table-search.component";
import { SharedConstants } from "../../shared/constants/shared.constants";
import { BehaviorSubject } from "rxjs";
import { AppControllerService } from "../../app-controller.service";
import { SearchContainerHeight } from "../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ModuleConfigService } from "../../shared/services/module-config/module-config.service";
import { SaveSearchService } from "../../shared/services/save-search/save-search.service";
import { SearchTableService } from "../../shared/services/table-column-mapping/search-table.service";
import { MapServiceService } from "../../core/settings/shared/map-service.service";
import { RequestStatusService } from "../../shared/services/request-status/request-status.service";
import _ from "underscore";
import { PoiSearchEnum, PoiSearchOption } from "./shared/enums/poi-search-enum";
import { POISConstants, POISHeadingEnumHeadingLookup } from "./poi.constants";
import { PoiSearchService } from "./shared/services/poi-search.service";
import { ArcGisPOIColumn } from "./shared/models/arcgis-poi-column.model";
import { POISearchColumnToArcGisColumnPOIsLookup } from "./shared/models/poi-search-to-arcgis.model";
import { AlertType } from "../../shared/models/alert";
import { Store } from "@ngrx/store";
import { AutoUnsub } from "../../shared/decorators/autounsub.decorator";
import { poiSearch } from "../../store/actions/tab-poi.actions";
let POIComponent = class POIComponent {
    appControllerService;
    poiSearchService;
    moduleConfigService;
    changeDetectorRef;
    saveSearchService;
    searchTableService;
    mapService;
    requestStatusService;
    store;
    tableSearchFilterComponent;
    pageHeading = POISConstants.Headings.PageHeadings;
    showSearchButton = true;
    POIAttributeToTableColumn;
    filterOptions;
    selectedPOISubject = new BehaviorSubject(undefined);
    selectedPoi;
    placeHolder;
    searchPlaceHolder;
    POISearchTableDataSource;
    isMapLoaded = false;
    parentComponentRef = "POIsComponent";
    preSelected;
    mapComponent;
    POIList = [];
    setMapLayerSubscription;
    listenForSearchChangesSubscription;
    poiSubscription;
    constructor(appControllerService, poiSearchService, moduleConfigService, changeDetectorRef, saveSearchService, searchTableService, mapService, requestStatusService, store) {
        this.appControllerService = appControllerService;
        this.poiSearchService = poiSearchService;
        this.moduleConfigService = moduleConfigService;
        this.changeDetectorRef = changeDetectorRef;
        this.saveSearchService = saveSearchService;
        this.searchTableService = searchTableService;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.store = store;
        this.initializeColumnToObjectMapping();
    }
    ngOnInit() {
        this.initializeConstants();
        this.finaliseMapSettings();
    }
    ngOnDestroy() {
        this.placeHolder = SharedConstants.SEARCH_BY_DEFAULT;
        this.POIList = [];
        this.POISearchTableDataSource = null;
        this.saveSearchService.clearSavedSearchResults();
        this.poiSearchService.clearPOIsList();
        this.changeDetectorRef.detectChanges();
    }
    setMapLayer() {
        this.setMapLayerSubscription = this.mapService.layerUrlListAsObservable.subscribe((POIS) => {
            if (POIS) {
                this.poiSearchService.clearURLList();
                POIS.forEach((POI) => {
                    if (POI.moduleId === Number(this.appControllerService.selectedModuleID) && POI.layerType === PoiSearchOption.Poi) {
                        this.poiSearchService.setURL(POI.layerType, POI.url);
                    }
                });
                this.setPOISearchOptions();
            }
        });
    }
    handleAdvancedSearch() {
    }
    setHeadings() {
        switch (this.poiSearchService.poiSearchType) {
            case PoiSearchOption.Poi:
                this.POIAttributeToTableColumn = POISHeadingEnumHeadingLookup;
                break;
        }
        this.poiSearchService.setTableColumnMap(this.POIAttributeToTableColumn);
        this.setFilterOptions();
        this.changeDetectorRef.detectChanges();
    }
    mapLoaded() {
        this.isMapLoaded = true;
    }
    POISelected($event) {
        this.selectedPOISubject.next($event);
    }
    async handleSimpleSearch(search) {
        await this.searchPOIs(search);
    }
    async doPOISearch(url, searchText, column) {
        this.requestStatusService.showBusySpinner(SharedConstants.POI_SEARCH_STATUS);
        // @ts-ignore
        try {
            // @ts-ignore
            await this.poiSearchService.doSearch(url, searchText, column, false)
                .then((POIsFound) => {
                if (POIsFound.length > 0) {
                    this.poiSearchService.addMapLocatorLinks(POIsFound);
                    this.changeDetectorRef.detectChanges();
                }
                else {
                    this.appControllerService.showMessage(`${SharedConstants.NO_ITEMS_AVAILABLE_MESSAGE} that matches your search term`, AlertType.Warning);
                }
                this.requestStatusService.removeBusySpinner(SharedConstants.POI_SEARCH_STATUS);
            });
        }
        catch (e) {
            this.requestStatusService.removeBusySpinner(SharedConstants.POI_SEARCH_STATUS);
        }
    }
    ngAfterViewInit() {
        this.listenForSelectedPOIChange();
        this.listenForSearchChanges();
    }
    finaliseMapSettings() {
        this.searchPlaceHolder = `${SharedConstants.SEARCH_PREFIX} ${this.pageHeading.toLocaleLowerCase()}`;
        this.setMapLayer();
        this.showMap(false);
    }
    setFilterOptions() {
        this.filterOptions = new Array();
        this.filterOptions.push(SharedConstants.FILTER_BY_DEFAULT);
        this.filterOptions.push(..._.values(this.POIAttributeToTableColumn.values()));
        this.changeDetectorRef.detectChanges();
    }
    initializeColumnToObjectMapping() {
        this.POIAttributeToTableColumn = POISHeadingEnumHeadingLookup;
    }
    setPOISearchOptions() {
        const searchOptionList = [];
        if (this.moduleConfigService.isStreetNamingModule() && this.poiSearchService.poiUrl && this.poiSearchService.poiUrl !== "") {
            searchOptionList.push(..._.values(PoiSearchEnum));
        }
        const POIOptions = [];
        searchOptionList.forEach((option) => {
            if (POIOptions.indexOf(option) < 0) {
                POIOptions.push(option);
            }
        });
        this.searchTableService.setPropertySearchOptions(POIOptions);
        this.poiSearchService.setSearchOptionLookup(PoiSearchEnum);
        this.preSelected = POIOptions[0];
        this.poiSearchService.setSelectedSearchOption(this.preSelected);
        this.searchTableService.setPreSelectedSearchOption(this.preSelected);
        this.selectedPoi = this.selectedPOISubject.asObservable();
        this.setHeadings();
    }
    showMap(displayMap) {
        if (displayMap) {
            this.isMapLoaded = true;
        }
        else {
            this.isMapLoaded = false;
        }
    }
    async searchPOIs(search) {
        if (search.column !== SharedConstants.SEARCH_BY_DEFAULT) {
            // @ts-ignore
            const column = this.getArcGISColumn(search.column);
            const url = this.poiSearchService.getLayerUrl(this.poiSearchService.poiSearchType);
            // @ts-ignore
            this.POISearchTableDataSource = await this.doPOISearch(url, search.text, column);
            this.store.dispatch(poiSearch({ value: this.POISearchTableDataSource }));
            this.changeDetectorRef.detectChanges();
        }
    }
    getArcGISColumn(column) {
        this.poiSearchService.setSelectedSearchOption(column);
        this.setHeadings();
        switch (this.poiSearchService.poiSearchType) {
            case PoiSearchOption.Poi:
                return POISearchColumnToArcGisColumnPOIsLookup.get(column);
        }
    }
    initializeConstants() {
        this.initializePageHeader();
        this.initializeSearchTableConstants();
        this.poiSearchService.clearPOIsList();
        this.poiSearchService.clearTableColumnMap();
        this.poiSearchService.setTableColumnMap(POISHeadingEnumHeadingLookup);
    }
    initializePageHeader() {
        this.pageHeading = POISConstants.Headings.PageHeadings;
    }
    initializeSearchTableConstants() {
        this.placeHolder = SharedConstants.SEARCH_BY_DEFAULT;
        this.POIList = [];
        this.poiSearchService.clearPOIsList();
        this.POISearchTableDataSource = null;
        this.saveSearchService.clearSavedSearchResults();
        this.searchTableService.changeContainerHeight(SearchContainerHeight.POIs);
        this.POIAttributeToTableColumn = POISHeadingEnumHeadingLookup;
    }
    listenForSelectedPOIChange() {
        this.poiSubscription = this.poiSearchService.mapLocationAsObservable.subscribe((selectedPOIId) => {
            if (selectedPOIId && selectedPOIId !== "") {
                this.viewSelectedPropertyOnMap(selectedPOIId);
            }
        });
    }
    listenForSearchChanges() {
        this.listenForSearchChangesSubscription = this.poiSearchService.poiListAsObservable.subscribe((items) => {
            this.POIList = items;
        });
    }
    viewSelectedPropertyOnMap(selectedPOIId) {
        try {
            const url = this.poiSearchService.getLayerUrl(PoiSearchOption.Poi);
            this.requestStatusService.showBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
            // @ts-ignore
            this.poiSearchService.doSearch(url, selectedPOIId, ArcGisPOIColumn.Id, true, PoiSearchOption.Poi, true).then((result) => {
                if (result.length > 0) {
                    this.setMapRoute(result);
                }
                this.requestStatusService.removeBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
            });
        }
        catch (e) {
            this.requestStatusService.removeBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        }
    }
    setMapRoute(POIs) {
        if (this.isMapLoaded) {
            this.showMap(true);
            this.mapComponent.removeGraphicsFromMap(POISConstants.SELECTED_POI_GRAPHICS_LAYER);
            const geometries = [];
            POIs.forEach((property) => {
                geometries.push(property.geometry);
            });
            this.mapComponent.addGeometriesOnMap(geometries, POISConstants.SELECTED_POI_GRAPHICS_LAYER);
            this.changeDetectorRef.detectChanges();
        }
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: PoiSearchService },
        { type: ModuleConfigService },
        { type: ChangeDetectorRef },
        { type: SaveSearchService },
        { type: SearchTableService },
        { type: MapServiceService },
        { type: RequestStatusService },
        { type: Store }
    ];
    static propDecorators = {
        tableSearchFilterComponent: [{ type: ViewChild, args: [TableSearchComponent,] }],
        mapComponent: [{ type: ViewChild, args: ["POIsMap", { static: true },] }]
    };
};
POIComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-poi",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], POIComponent);
export { POIComponent };
